import React, {useMemo, useState} from 'react';
import {Collapse} from 'antd';
import {useProjectForm} from "../../../providers/ProjectFormProvider";
import Service from "../../../models/Service";
import Project from "../../../models/Project";
import {useAPI} from "../../../config/API";


const TemplateCollapsableOverview = ({currentStep}) => {
    const [activeKey, setActiveKey] = useState(0);

    const {formModel: project, isProjectUpdating} = useProjectForm();
    let progress = Project.progressForStep(currentStep, true);
    const [styledCircle, setStyledCircle] = useState(null)

    const {
        data: template,
    } = useAPI(['fetchProjectTemplate', project.template?.id], {
        enabled: project?.isService?.() === true && !!project.template?.id
    })


    const navSections = useMemo(() => {
        if (!project || !currentStep) return [];

        let sections = [];
        let formSections = Project.formSections(project.isService());

        let prevSectionPercent = 0, totalPercent = 0;

        for (let [section, sectionPercent] of Object.entries(formSections)) {
            totalPercent += sectionPercent;
            if (section === Project.ProjectSections.SectionReview) {
                prevSectionPercent = totalPercent;
                continue;
            }

            sections.push((
                <div key={section} className={TB.mapClass("position-progress-item", {
                    "active": progress >= prevSectionPercent && progress < totalPercent,
                    "complete": progress >= prevSectionPercent
                })}>
                    <h5>{section}</h5>
                </div>
            ))
            prevSectionPercent = totalPercent;
        }
        return sections;
    }, [project, currentStep, isProjectUpdating]);

    return (
        <React.Fragment>
            <div className="template-collapsable-overview flex flex-col items-stretch bg-[#F7F8FA] px-5 py-6">

                <div className="flex flex-row items-stretch justify-between gap-4">
                    <div className="flex flex-row items-center gap-3">
                        {template && (
                            <React.Fragment>
                                <div className="w-20 h-20 flex flex-col items-center justify-center" style={Service.categoryIcon(template.category.name)}>
                                    {template?.category?.name && (
                                        <i className={Service.categoryIconClass(template.category.name)}/>
                                    )}
                                </div>
                                <div className="flex flex-col gap-1">
                                    {template?.category?.name && (
                                        <p className="text-sm uppercase">
                                            {template?.category?.name}
                                        </p>
                                    )}
                                    <p className="text-lg font-medium">
                                        {project.template.name}
                                    </p>
                                </div>
                            </React.Fragment>
                        )}
                    </div>

                    <div className="min-w-[600px] max-w-[700px] flex-grow flex flex-col justify-between">
                        <button type="button" className="flex items-center outline-none self-end" onClick={() => setActiveKey(!!activeKey ? null : 1)}>
                            {!!activeKey ? 'Hide' : 'Show'} Overview <i className={`fas fa-caret-down px-1 text-xl ${!!activeKey ? 'rotate-180' : ''}`} />
                        </button>

                        <div className="project-wizard-progress" id="project-wizard-progress">
                            {navSections}
                        </div>
                    </div>

                </div>

                <Collapse activeKey={activeKey}>
                    <Collapse.Panel
                        showArrow={false}
                        header={null}
                        key={1}
                    >
                        <div className="pt-6">
                            <div className="flex gap-6">
                                {template?.duration && (
                                    <p className="font-semibold">
                                        <span className="uppercase">TIME:&nbsp;</span>
                                        {template.duration}
                                    </p>
                                )}

                                <p className="font-semibold">
                                    <span className="uppercase">TYPICAL PRICE:&nbsp;</span>
                                    {project.estimatedCostRangeForService()}
                                </p>
                            </div>
                            <p className="pt-2">{template?.description}</p>
                        </div>
                    </Collapse.Panel>
                </Collapse>
            </div>

            {/*<div className="bg-white flex flex-col items-stretch py-4 px-8">*/}

            {/*</div>*/}
        </React.Fragment>
    );
};

export default TemplateCollapsableOverview;